import { toRem } from "../../../../helpers/theme";
import { normalizeDimension } from "../../../../helpers/utils";

const style = ({ theme, noTitle, bottomSpacing }) => ({
    position: "relative",
    margin: 0,
    marginBottom: bottomSpacing ? normalizeDimension(bottomSpacing, true) : toRem(17),
    [theme.breakpoints.up("md")]: {
        marginBottom: bottomSpacing ? normalizeDimension(bottomSpacing, true) : toRem(35),
    },
    "& .textBlock": {
        "&_title": {
            fontSize: toRem(20),
            lineHeight: 1.2,
            fontWeight: theme.typography.fontWeight.black,
            [theme.breakpoints.up("md")]: {
                fontSize: toRem(24),
            },
        },
        "&_description": {
            marginTop: noTitle ? undefined : toRem(10),
            fontSize: toRem(16),
            lineHeight: 1.4,
            [theme.breakpoints.up("md")]: {
                marginTop: noTitle ? undefined : toRem(14),
                lineHeight: 1.6,
            },
            "& p": {
                fontSize: "inherit",
                lineHeight: "inherit",
            },
            "& > *:last-child": {
                marginBottom: 0,
            },
        },
    },
    // Accent colors for text
    "& .accentPrimary": {
        color: theme.colors.accent.text.primary,
    },
    "& .accentSecondary": {
        color: theme.colors.accent.text.secondary,
    },
    "& .accentTertiary": {
        color: theme.colors.accent.text.tertiary,
    },
    "& .accentQuaternary": {
        color: theme.colors.accent.text.quaternary,
    },
});

export default style;
